export default __webpack_public_path__ + "static/1.2_DE-e48e329e1629d922be5f9039a76712a4.webp";